import { INavigation } from "@interfaces/ux/navigation.interface";
import { ILang, UserDTO } from "@models/*";
import { BasePresenter } from "@presenters/base/base.presenter";
import { INavigationService, NavigationService } from "@services/proyecta/navigation.service";
import { ISessionService, SessionService } from "@services/proyecta/session.service";
import { useSelector } from "react-redux";
import { Enums, moment, String, Utilities, Constants } from "../../utils/utilities";

export class NavigationPresenter extends BasePresenter<INavigation> {
    private client: INavigationService;
    private clientSession: ISessionService;
    private currentLang: ILang;
    private langs: ILang[];
    private user: UserDTO;
    public params: any;

    constructor(view: INavigation) {
        super(view);
        this.client = new NavigationService();
        this.clientSession = new SessionService();
        this.langs = useSelector(this.context.sessionStore.selectLangs);
        this.currentLang = useSelector(this.context.sessionStore.selectLang);
        this.params = useSelector(this.context.sessionStore.selectParams);
        this.user = useSelector(this.context.sessionStore.selectUser) as UserDTO;

    }
    private get currentLangId() {
        if (Utilities.isNullObject(this.currentLang)) {
            return 1;
        }
        return this.currentLang.id;
    }

    public getLangs() {
        return this.langs;
    }

    public getCurrentLang(): ILang {
        return this.currentLang || { id: 1, label: 'ES' };
    }

    public setLang = (currentLang: ILang) => {
        this.dispatcher(this.context.sessionStore.setLang(currentLang));
    }

    public async getLogo() {
        const logo = await this.client.getLogo();
        this.view.state.setLogo(logo);
    }

    public getRoot = () => {
        return '/proyecta/presupuesto'
    }

    public getUser = () => {
        if (!Utilities.isNullObject(this.user)) {
            if (!Utilities.isNullObject(this.user.currentUser)) {
                return {
                    displayName: this.user.currentUser.displayName,
                    email: this.user.currentUser.userPrincipalName,
                    department: this.user.currentUser.department,
                    groups: this.user.userGroups.map((group: any) => ({ id: group.id, name: group.displayName })),
                    rol: this.user.currentUser.jobTitle,
                    country: this.user.currentUser.country,
                };
            }
        }
        return null
    }


    public async getNavBarItems() {
        const items = await this.client.getNavBarData(this.currentLangId);
        this.view.state.setNavbarItems(items);
    }

    public async getSubMenuItems(listName: string) {
        const items = await this.client.getSubMenuData(listName, this.currentLangId);
        return items;
    }

    public getTotalPermissions() {
        const ADMIN_GROUP = this.params?.[Enums.Params.proyectaAdminModule]
        let userGroupsName: any[] = this?.user?.userGroups?.map((x: any) => x.displayName)

        return (userGroupsName?.includes(ADMIN_GROUP))
    }

}